import Vue from 'vue';
import PageNav from '@/components/page-nav/PageNav.vue';
var UbLogo = require("@/assets/svgs/ub-logo.svg");
var UbSymbols = require("@/assets/svgs/ub-symbole.svg");
import Fokus from '@/svgs/fokus/Fokus.vue';
import Leidenschaft from '@/svgs/leidenschaft/Leidenschaft.vue';
import Spuren from '@/svgs/spuren/Spuren.vue';
var TimelineMax = require("TimelineMax");
var TweenMax = require("TweenMax");
var EasePack = require("EasePack");
var ScrollMagic = require('ScrollMagic');
export default Vue.extend({
    name: 'Services',
    components: {
        'page-nav': PageNav,
        'ub-logo': UbLogo,
        'ub-symbols': UbSymbols,
        'fokus': Fokus,
        'leidenschaft': Leidenschaft,
        'spuren': Spuren
    },
    metaInfo: {
        // if no subcomponents specify a metaInfo.title, this title will be used
        title: 'Leistungen',
        // all titles will be injected into this template
        titleTemplate: '%s | Ultrabold Kommunikationsdesign GmbH'
    },
    data() {
        return {
            controller: new ScrollMagic.Controller(),
        };
    },
    mounted() {
        this.fokus();
        this.leidenschaft();
        this.spuren();
    },
    methods: {
        fokus() {
            //@ts-ignore
            let lengthMitte = document.getElementById('kreis_mitte').getTotalLength();
            let circleMitte = document.getElementById('kreis_mitte');
            circleMitte.style.strokeDasharray = lengthMitte;
            circleMitte.style.strokeDashoffset = lengthMitte;
            //@ts-ignore
            let lengthOben = document.getElementById('kreis_oben').getTotalLength();
            let circleOben = document.getElementById('kreis_oben');
            circleOben.style.strokeDasharray = lengthOben;
            circleOben.style.strokeDashoffset = lengthOben;
            //@ts-ignore
            let lengthUnten = document.getElementById('kreis_unten').getTotalLength();
            let circleUnten = document.getElementById('kreis_unten');
            circleUnten.style.strokeDasharray = lengthOben;
            circleUnten.style.strokeDashoffset = lengthOben;
            let tl = new TimelineMax();
            tl.to('#kreis_mitte', 1, {
                strokeDashoffset: 0,
                ease: EasePack.Linear.easeNone
            }, 0)
                .fromTo('.hand_unten', 1, {
                x: 200,
                y: 200,
                ease: EasePack.Linear.easeNone
            }, {
                x: 0,
                y: 0,
                ease: EasePack.Linear.easeNone
            }, 'kreis_mitte')
                .fromTo('.hand_oben', 1, {
                x: -200,
                y: -200,
                ease: EasePack.Linear.easeNone
            }, {
                x: 0,
                y: 0,
                ease: EasePack.Linear.easeNone
            }, 'kreis_mitte')
                .to('#kreis_oben', 1, {
                strokeDashoffset: 0,
                ease: EasePack.Linear.easeNone
            }, 'hand_oben')
                .to('#kreis_unten', 1, {
                strokeDashoffset: 0,
                ease: EasePack.Linear.easeNone
            }, 'hand_oben');
            let handsScene = new ScrollMagic.Scene({
                tweenChanges: true,
                offset: window.innerWidth < 641 ? -500 : 0,
                triggerElement: '.first_section',
                triggerHook: 0.5,
                duration: 350
            })
                .setTween([tl])
                .addTo(this.controller);
        },
        leidenschaft() {
            //@ts-ignore
            let lengthCircle = document.getElementById('circle').getTotalLength();
            let circle = document.getElementById('circle');
            circle.style.strokeDasharray = lengthCircle;
            circle.style.strokeDashoffset = lengthCircle;
            let tl = new TimelineMax();
            tl.fromTo('.leidenschaft #Dophin', 1, {
                transform: 'scale(0)'
            }, {
                transform: 'scale(1)'
            })
                .to('.leidenschaft #circle', 1, {
                strokeDashoffset: 0,
                ease: EasePack.Linear.easeNone
            });
            let leidenSchaftScene = new ScrollMagic.Scene({
                offset: 0,
                triggerElement: '.second_section',
                triggerHook: 0.5,
                duration: 350
            })
                .setTween(tl)
                .addTo(this.controller);
        },
        spuren() {
            let tl = new TimelineMax();
            tl.fromTo('.spuren #Circle', 1, {
                y: -200,
                opacity: 0
            }, {
                y: 0,
                opacity: 1
            })
                .fromTo('#snake', 1, {
                y: 200,
                opacity: 0
            }, {
                y: 0,
                opacity: 1
            }, 0);
            let spurenScene = new ScrollMagic.Scene({
                offset: 0,
                triggerElement: '.third_section',
                triggerHook: 0.5,
                duration: 350
            })
                .setTween(tl)
                .addTo(this.controller);
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./src/views/Services/Services.ts
// module id = null
// module chunks = 